import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCircleTool = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			opacity: .4,
			x: 5,
			y: 5,
			width: 22,
			height: 22,
			rx: 11,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter0_d)",
			children: /* @__PURE__ */ _jsx("rect", {
				x: 13.5,
				y: 13.5,
				width: 5,
				height: 5,
				rx: 2.5,
				fill: "currentColor"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
			id: "filter0_d",
			x: 10.5,
			y: 11.5,
			width: 11,
			height: 11,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 1 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.5 }),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect1_dropShadow",
					result: "shape"
				})
			]
		}) })
	]
});
const ForwardRef = forwardRef(SvgCircleTool);
export { ForwardRef as ReactComponent };
